export default __webpack_public_path__ + "static/media/spaceExplorer.d09323e8.gif";